import cn from 'classnames'
import PropTypes from 'prop-types'

import { ReactComponent as IconChevronSm } from 'assets/icons/IconChevronSm.svg'

const NumberBox = ({
  wrapperClassName,
  className,
  showValidationErrors = false,
  label = '',
  value = null,
  children,
  onChange,
  onChangeAdd,
  onChangeMinus,
  dataCy,
  ...props
}) => {
  const isFirefox = typeof InstallTrigger !== 'undefined'

  return (
    <div
      className={cn('numberbox', wrapperClassName, {
        '-error': showValidationErrors,
      })}
      data-cy={dataCy}
    >
      <input
        onChange={onChange}
        className={cn('numberbox__input', className)}
        placeholder={isFirefox ? '' : '#'}
        value={value}
        type="number"
        {...props}
      />
      <label className="numberbox__label">{label}</label>
      <div className="numberbox__arrows">
        <button
          type="button"
          onClick={onChangeAdd}
          className="numberbox__arrow-up"
        >
          <IconChevronSm />
        </button>
        <button
          type="button"
          onClick={onChangeMinus}
          className="numberbox__arrow-down"
        >
          <IconChevronSm />
        </button>
      </div>
      {children}
    </div>
  )
}

NumberBox.propTypes = {
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
  showValidationErrors: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  onChangeMinus: PropTypes.func,
  onChangeAdd: PropTypes.func,
  value: PropTypes.number,
  dataCy: PropTypes.string,
}

export default NumberBox
